module.exports = __webpack_public_path__ + "img/hr-V-L-246-unload-standup-base.222e1c31.png";